import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();